"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerYearSelectorStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _selectV = require("../../../selectV2");
var _datePickerTheme = require("./datePickerTheme");
/**
 * This is a one-off CSS-only override of the SelectV2 to create an inline, 32px tall borderless
 * variant. We considered adding this as a variant to the SelectV2, but it's so specific to the
 * DatePicker that it didn't make sense to make an official API for it.
 */
const DatePickerYearSelectorStyled = (0, _styled.default)(_selectV.SelectV2)`
    min-height: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _datePickerTheme.datePickerTheme.yearSelector.minheight[themeMode];
}};

    & > button {
        // We have to apply this here instead of the normal way of applying it at the root since
        // we're applying the background-color below using the aria-expanded attribute. If we could
        // use the :has() selector, this would be easier.
        border-radius: 6px;

        height: 32px;

        // Since we turn off the border, we need to add this in to show the user it's interactive.
        cursor: pointer;
    }

    &:hover > button {
        background-color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _datePickerTheme.datePickerTheme.yearSelector.backgroundColor.hover[themeMode];
}};
    }

    & > button:active,
    & > button[aria-expanded="true"] {
        background-color: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _datePickerTheme.datePickerTheme.yearSelector.backgroundColor.expanded[themeMode];
}};
    }

    & > button > span {
        font-weight: 700;
        font-size: 16px;
        // This is kinda weird, but for the 16px font size, we need to set the line-height to 20px
        // to make sure the scrollHeight matches the height of the text. If we don't, the reported
        // scrollHeight might be larger than the height of the text. This would cause the
        // TypeRampV2's tooltip to show up.
        line-height: 20px;
    }

    & > button + div {
        // This is a fake button anyways, just turn it off.
        pointer-events: none;
    }

    // This smaller target is used in this more compact variant.
    & > button + div > span {
        height: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _datePickerTheme.datePickerTheme.yearSelector.iconHeight[themeMode];
}};
        width: 24px;
    }

    // Turn off the "focus" ring we're using as the "border" Except in Lodestar mode, we DO want the
    // border when the selector is focused, otherwise we have no focus indicator. Ursa has a border
    // AND a focus ring so it's easier.
    ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  if (themeMode === "ursa-light") {
    return `
                &::after {
                    border: none;
                }
            `;
  }
  return `
                // When the button is focused via the keyboard, we want to show the border.
                // When the button is focused via the mouse, we don't want to show the border.
                &:not(:focus-within)::after,
                &:has(> button:active)::after {
                    border: none;
                }
            `;
}}}
`;
exports.DatePickerYearSelectorStyled = DatePickerYearSelectorStyled;
//# sourceMappingURL=DatePickerYearSelectorStyled.js.map